import React from 'react';
import moment from 'moment';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Link } from 'react-router-dom';

const ReportGridView = ({ reportedAdsRows, loading }) => {
  return (
    <>
      <div className="row my-3">
        {loading ? (
          Array.from({ length: 8 }).map((_, idx) => (
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 m-b30" key={idx}>
              <Skeleton height={300} style={{ borderRadius: '16px' }} />
            </div>
          ))
        ) : (
          reportedAdsRows.map((item, idx) => (
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 m-b30" key={idx}>
              <div className="card property-card style-1 h-100">
                <div className="card-body p-3">
                  {/* Property Title */}
                  <div className="mb-3">
                    <h6 className="text-primary mb-1">Property Title</h6>
                    <p className="mb-0 fw-semibold" title={item.propertyId?.title}>
                      {item.propertyId?.title || 'N/A'}
                    </p>
                  </div>

                  {/* Reason */}
                  <div className="mb-3">
                    <h6 className="text-primary mb-1">Reason</h6>
                    <span className={`badge badge-${
                      item.reason === 'Offensive content' ? 'danger' :
                      item.reason === 'fraud' ? 'danger' :
                      item.reason === 'Duplicate ad' ? 'info' :
                      item.reason === 'Product already sold' ? 'warning' :
                      'secondary'
                    }`}>
                      {item.reason === 'Offensive content' ? 'Offensive Content' :
                       item.reason === 'Duplicate ad' ? 'Duplicate Ad' :
                       item.reason === 'Product already sold' ? 'Product Already Sold' :
                       item.reason?.charAt(0).toUpperCase() + item.reason?.slice(1) || 'N/A'}
                    </span>
                  </div>

                  {/* Comment */}
                  <div className="mb-3">
                    <h6 className="text-primary mb-1">Comment</h6>
                    <p className="mb-0 text-muted small" 
                       style={{ 
                         display: '-webkit-box',
                         WebkitLineClamp: 3,
                         WebkitBoxOrient: 'vertical',
                         overflow: 'hidden',
                         textOverflow: 'ellipsis',
                         lineHeight: '1.4em',
                         maxHeight: '4.2em'
                       }}
                       title={item.comment}>
                      {item.comment || 'N/A'}
                    </p>
                  </div>

                  {/* Reported By */}
                  <div className="mb-3">
                    <h6 className="text-primary mb-1">Reported By</h6>
                    <div className="small">
                      <div className="mb-1">
                        <strong>Name:</strong> {item.userId?.name || 'N/A'}
                      </div>
                      <div className="mb-1">
                        <strong>Phone:</strong> {item.userId?.phone || 'N/A'}
                      </div>
                      <div className="mb-1">
                        <strong>Email:</strong> {item.userId?.email || 'N/A'}
                      </div>
                    </div>
                  </div>

                  {/* Reported Date */}
                  <div className="mb-3">
                    <h6 className="text-primary mb-1">Reported Date</h6>
                    <p className="mb-0 small text-muted">
                      {moment(item.createdAt).format("DD/MM/YYYY, hh:mm A")}
                    </p>
                  </div>
                </div>

                {/* Card Footer */}
                <div className="card-footer bg-light p-3">
                  <div className="d-flex justify-content-center">
                    <Link 
                      to={`/property-details/${item.propertyId?._id}?nfrm=rptd`} 
                      className="btn btn-secondary btn-sm"
                    >
                      <i className="fa fa-eye me-1"></i>
                      View Property
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default ReportGridView;